// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

import apiHandle from '../../../../configs/apiConfig'


export const manageExamCreate = createAsyncThunk('manageExam/application/create', async (params) => {
  const response = await apiHandle('POST', 'application/paybalance', params)
  return response
})

export const manageExamRefund = createAsyncThunk('manageExam/application/refund', async (params) => {
  const response = await apiHandle('POST', 'application/refund', params)
  return response
})

export const manageExamDelete = createAsyncThunk('manageExam/application/delete', async (params) => {
  const response = await apiHandle('POST', 'application/delete', params)
  return response
})


export const manageExamPDFCreate = createAsyncThunk('manageExam/application/pdf/create', async (params) => {
  const response = await apiHandle('POST', 'application/pdf', params)
  return response
})

export const manageExamReaderCard = createAsyncThunk('manageExam/manageExamReaderCard', async () => {
  const response = await apiHandle('GET', 'mockreadercard')
  return response
})

export const getDataTable = createAsyncThunk('manageExam/getDataTable', async (params) => {
  const response = await apiHandle('GET', 'application/gettable', params)
  return response
})

export const manageExamDataDetail = createAsyncThunk('manageExam/manageExamDataDetail', async (params) => {
  const response = await apiHandle('GET', 'application/get', params)
  return response
})

export const manageExamGetCourse = createAsyncThunk('manageExam/manageExamGetCourse', async (params) => {
  const response = await apiHandle('GET', 'application/getformanageExam', params)
  return response
})

export const getAllData = createAsyncThunk('manageExam/getAllData', async () => {
  const response = await axios.get('/api/users/list/all-data')
  return response.data
})

export const getData = createAsyncThunk('manageExam/getData', async params => {
  const response = await axios.get('/api/users/list/data', params)
  return {
    params,
    data: response.data.users,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('manageExam/getUser', async id => {
  const response = await axios.get('/api/users/user', { id })
  return response.data.user
})

export const addUser = createAsyncThunk('manageExam/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('manageExam/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

const defaultCoruseCost = {
  course_id: '',
  course_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultOtherCost = {
  other_fee_id: null,
  other_fee_name: null,
  promotion_code: null,
  exam_date: null,
  cost: null,
  discount: null,
  paid: null,
  pay_type: null
}

const defaultPayments = {
  payment_id: null,
  payment_code: null,
  pay_type: null,
  paid: null,
  createdAt: null
}


const defaultReisterDetail = {
  is_foreigner: false,
  prefix: '',
  name: '',
  idcard: '',
  birthday: null,
  address: null,
  moo: '',
  soi: '',
  street: '',
  subdistrict: '',
  district: '',
  province: '',
  phone_1: '',
  phone_2: '',
  age: '',
  course: [defaultCoruseCost],
  other_fee: [defaultOtherCost],
  payments: [defaultPayments],
  paid: '',
  discount: '',
  net: '',
  balance: '',
  total: '',
  // pay_type: 'เงินสด',
  status: null,
  application_code: null,
  course_id: '',
  createStatus: false,
  application_id: null,
  pdf: []
}


export const manageExamSlice = createSlice({
  name: 'manageExam',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null,
    searchCriteria: {
      branch: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      status: { label: 'ค้างชำระ', value: 'ค้างชำระ' },
      type: { label: 'ทั้งหมด', value: 'ทั้งหมด' },
      text: ''
    },
    manageExamData: {
      data: [],
      filter: {
        branch: [],
        status: [],
        type: []
      },
      meta: {},
      isLoading: false
    },
    manageExamDetail: {
      isEdit: false,
      dropdown: {
        course: [],
        other_fee: []
      },
      userData: defaultReisterDetail
    },
    alert: {
      active: false,
      message: ''
    },
    refundAndDelete: {
      application_id: null,
      note: null,
      value: null,
      err: false
    }
  },
  reducers: {
    searchCriteria: (state, action) => {
      if (action.type === 'manageExam/searchCriteria') {
        state.searchCriteria[action.payload.target] = action.payload.value
      }
    },
    manageExamNew: (state, action) => {
      if (action.type === 'manageExam/manageExamNew') {
        state.manageExamDetail.isEdit = false
        state.manageExamDetail.userData = defaultReisterDetail
      }
    },
    manageExamAddHandle: (state, action) => {
      if (action.type === 'manageExam/manageExamAddHandle') {
        if (action.payload.target === 'course') {
          state.manageExamDetail.userData.course.push(defaultCoruseCost)
        }
        if (action.payload.target === 'other') {
          state.manageExamDetail.userData.other_fee.push(defaultOtherCost)
        }

      }
    },
    manageExamDeleteHandle: (state, action) => {
      if (action.type === 'manageExam/manageExamDeleteHandle') {
        if (action.payload.target === 'course') {
          state.manageExamDetail.userData.course.splice(action.payload.index, 1)
        }
        if (action.payload.target === 'other') {
          state.manageExamDetail.userData.other_fee.splice(action.payload.index, 1)
        }

      }

    },
    manageExamDropdownHandle: (state, action) => {
      if (action.type === 'manageExam/manageExamDropdownHandle') {
        console.log(action.payload.target)
        if (action.payload.target === 'course' && state.manageExamDetail.isEdit === false) {
          state.manageExamDetail.userData.course[action.payload.index].course_id = action.payload.value.course_id
          state.manageExamDetail.userData.course[action.payload.index].course_name = action.payload.value.name
          state.manageExamDetail.userData.course[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'examDate') {
          state.manageExamDetail.userData.course[action.payload.index].exam_date = action.payload.value
        }
        if (action.payload.target === 'other' && state.manageExamDetail.isEdit === false) {
          state.manageExamDetail.userData.other_fee[action.payload.index].other_fee_id = action.payload.value.other_fee_id
          state.manageExamDetail.userData.other_fee[action.payload.index].other_fee_name = action.payload.value.name
          state.manageExamDetail.userData.other_fee[action.payload.index].cost = action.payload.value.price
        }
        if (action.payload.target === 'pay_type') {
          state.manageExamDetail.userData[action.payload.mode][action.payload.index].pay_type = action.payload.value
        }
      }
    },
    manageExamOnChangeHandle: (state, action) => {
      if (action.type === 'manageExam/manageExamOnChangeHandle') {
        if (action.payload.target === 'paid') {
          state.manageExamDetail.userData[action.payload.mode][action.payload.index][action.payload.target] = action.payload.value
        } else {
          state.manageExamDetail.userData[action.payload.target] = action.payload.value
        }

      }
    },
    manageExamLoading: (state, action) => {
      if (action.type === 'manageExam/manageExamLoading') {
        state.manageExamData.isLoading = true
      }
    },
    manageExamAlert: (state, action) => {
      if (action.type === 'manageExam/manageExamAlert') {
        state.alert.active = false
        state.alert.message = ''
        state.alert.err = false
      }
    },
    manageExamRefundDelete: (state, action) => {
      if (action.type === 'manageExam/manageExamRefundDelete') {
        if (action.payload.target === null) {
          state.refundAndDelete.application_id = null
          state.refundAndDelete.note = null
          state.refundAndDelete.value = null
        } else {
          state.refundAndDelete[action.payload.target] = action.payload.value
        }

      }
    }

  },
  extraReducers: builder => {
    builder
      .addCase(manageExamCreate.fulfilled, (state, action) => {
        if (action.type === 'manageExam/application/create/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.alert.active = true
            state.alert.message = action.payload.data.pdf
            // state.manageExamDetail.userData.createStatus = true
            // state.manageExamDetail.userData.pdf = action.payload.data
          }
        }
      })
      .addCase(manageExamRefund.fulfilled, (state, action) => {
        if (action.type === 'manageExam/application/refund/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.err = true
            state.alert.message = action.payload.message
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(manageExamDelete.fulfilled, (state, action) => {
        if (action.type === 'manageExam/application/delete/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.refundAndDelete.application_id = null
            state.refundAndDelete.note = null
            state.refundAndDelete.value = null
            state.alert.active = true
            state.alert.message = action.payload.message
          }
        }
      })
      .addCase(getDataTable.fulfilled, (state, action) => {
        if (action.type === 'manageExam/getDataTable/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.manageExamData = action.payload
            state.manageExamData.isLoading = false
          }
        }
      })
      .addCase(manageExamDataDetail.fulfilled, (state, action) => {
        if (action.type === 'manageExam/manageExamDataDetail/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            console.log(action)
            state.manageExamDetail.isEdit = true
            state.manageExamDetail.userData.prefix = action.payload.data.customer.prefix ? action.payload.data.customer.prefix : ''
            state.manageExamDetail.userData.name = action.payload.data.customer.name ? action.payload.data.customer.name : ''
            state.manageExamDetail.userData.idcard = action.payload.data.customer.idcard ? action.payload.data.customer.idcard : ''
            state.manageExamDetail.userData.birthday = action.payload.data.customer.birthday ? action.payload.data.customer.birthday : null
            state.manageExamDetail.userData.address = action.payload.data.customer.address ? action.payload.data.customer.address : ''
            state.manageExamDetail.userData.moo = action.payload.data.customer.moo ? action.payload.data.customer.moo : ''
            state.manageExamDetail.userData.soi = action.payload.data.customer.soi ? action.payload.data.customer.soi : ''
            state.manageExamDetail.userData.street = action.payload.data.customer.street ? action.payload.data.customer.street : ''
            state.manageExamDetail.userData.province = action.payload.data.customer.province ? action.payload.data.customer.province : ''
            state.manageExamDetail.userData.district = action.payload.data.customer.district ? action.payload.data.customer.district : ''
            state.manageExamDetail.userData.subdistrict = action.payload.data.customer.subdistrict ? action.payload.data.customer.subdistrict : ''
            state.manageExamDetail.userData.phone_1 = action.payload.data.customer.phone_1 ? action.payload.data.customer.phone_1 : ''
            state.manageExamDetail.userData.phone_2 = action.payload.data.customer.phone_2 ? action.payload.data.customer.phone_2 : ''
            state.manageExamDetail.userData.status = action.payload.data.status ? action.payload.data.status : null
            state.manageExamDetail.userData.application_code = action.payload.data.application_code ? action.payload.data.application_code : null
            state.manageExamDetail.userData.paid = action.payload.data.paid === 0 ? '0' : action.payload.data.paid
            state.manageExamDetail.userData.course_id = action.payload.data.paid ? action.payload.data.course_id.toString() : ''
            state.manageExamDetail.userData.discount = action.payload.data.discount === 0 ? '0' : action.payload.data.discount.toString()
            state.manageExamDetail.userData.net = action.payload.data.net === 0 ? '0' : action.payload.data.net.toString()
            state.manageExamDetail.userData.balance = action.payload.data.balance === 0 ? '0' : action.payload.data.balance.toString()
            state.manageExamDetail.userData.total = action.payload.data.total === 0 ? '0' : action.payload.data.total.toString()
            state.manageExamDetail.userData.payments = action.payload.data.payments
            state.manageExamDetail.userData.application_id = action.payload.data.application_id
            state.manageExamDetail.userData.is_foreigner = action.payload.data.customer.is_foreigner
            state.manageExamDetail.userData.course = [
              {
                course_id: action.payload.data.course_id ? action.payload.data.course_id.toString() : '',
                course_name: null,
                promotion_code: null,
                exam_date: null,
                cost: action.payload.data.balance ? action.payload.data.balance.toString() : '',
                discount: null,
                paid: null,
                pay_type: null
              }
            ]
          }
        }
      })
      .addCase(manageExamGetCourse.fulfilled, (state, action) => {
        if (action.type === 'manageExam/manageExamGetCourse/fulfilled') {
          if (action.payload.status === 'error') {
            //handleError
          } else {
            state.manageExamDetail.dropdown.course = action.payload.course
            state.manageExamDetail.dropdown.other_fee = action.payload.other_fee
          }
        }
      })
      .addCase(manageExamReaderCard.fulfilled, (state, action) => {
        if (action.type === 'manageExam/manageExamReaderCard/fulfilled') {
          if (action.payload.result === 'ok') {
            state.manageExamDetail.userData.prefix = action.payload.title_th
            state.manageExamDetail.userData.name = `${action.payload.fname_th} ${action.payload.sname_th}`
            state.manageExamDetail.userData.idcard = action.payload.nat_id
            state.manageExamDetail.userData.birthday = action.payload.birthdate
            state.manageExamDetail.userData.address = action.payload.address_no
            state.manageExamDetail.userData.street = action.payload.address_road
            state.manageExamDetail.userData.province = action.payload.address_provinice
            state.manageExamDetail.userData.district = action.payload.address_amphor
            state.manageExamDetail.userData.subdistrict = action.payload.address_tumbol
            state.manageExamDetail.userData.age = null

          } else {
            //handleError
          }
        }
      })
      .addCase(manageExamPDFCreate.fulfilled, (state, action) => {
        console.log(action)
        if (action.type === 'manageExam/application/pdf/create/fulfilled') {
          if (action.payload.status === 'success') {
            window.open(action.payload.data.pdf, '_blank')
          } else {
            //handleError
          }
        }
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })

  }
})

export const { searchCriteria, manageExamNew, manageExamAddHandle, manageExamDropdownHandle, manageExamDeleteHandle, manageExamOnChangeHandle, manageExamLoading, manageExamAlert, manageExamRefundDelete } = manageExamSlice.actions

export default manageExamSlice.reducer
